export var PaletteVariantsEnum;
(function (PaletteVariantsEnum) {
    PaletteVariantsEnum["PRIMARY"] = "primary";
    PaletteVariantsEnum["SECONDARY"] = "secondary";
    PaletteVariantsEnum["SUCCESS"] = "success";
    PaletteVariantsEnum["WARNING"] = "warning";
    PaletteVariantsEnum["DANGER"] = "danger";
    PaletteVariantsEnum["DISABLED"] = "disabled";
})(PaletteVariantsEnum || (PaletteVariantsEnum = {}));
//# sourceMappingURL=types.js.map